/** Where the Ask FFH page lives, and what the menu item links to. */
export const ASK_FFH_PATH = '/chat';

/** Longest question a member may type (the backend refuses longer). */
export const MAX_QUESTION_LENGTH = 1000;

/** The page's query parameter naming the chat on show, so a reload reads it back. */
export const CONVERSATION_QUERY_KEY = 'id';
